import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const SvgComponent = props => (
    <Svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
        <Path
            d="M2.128 7.62212C2.3915 7.86885 2.6883 8.11871 3.03354 8.34361C3.81486 8.85589 4.80204 9.24959 5.99498 9.25C7.18792 9.25041 8.18696 8.85737 8.96493 8.34251C9.31305 8.11472 9.61878 7.86194 9.88212 7.61539C10.315 7.20032 10.6327 6.79144 10.8446 6.48556C11.0564 6.17968 11.0472 5.80815 10.8443 5.51774C10.6353 5.21483 10.3142 4.80262 9.88108 4.38725L9.87806 4.39037C9.61456 4.1374 9.3117 3.88754 8.96344 3.65951C8.96344 3.65951 8.96344 3.65951 8.95435 3.65639C8.17908 3.14412 7.1919 2.75041 5.9929 2.75C4.79997 2.75584 3.81304 3.14887 3.03204 3.66062C2.68997 3.88841 2.3903 4.13494 2.12697 4.38149C1.69413 4.79657 1.36726 5.20856 1.15541 5.51444C0.943568 5.82033 0.952773 6.19809 1.15573 6.48851C1.37079 6.79141 1.6949 7.20675 2.128 7.62212Z"
            fill="#6B4235"
        />
    </Svg>
);
export default SvgComponent;
